import { render } from "./BlocksInfoView.vue?vue&type=template&id=3df24daa"
import script from "./BlocksInfoView.vue?vue&type=script&lang=js"
export * from "./BlocksInfoView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__